import { Box, Flex, Spinner, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getMonthlyReportPivotCasesByClient } from "../../../Http/Index"
import { PivotTable } from "./PivotTable"

interface Props {
  selectedMonth: string
  selectedQuarter?: string
  selectedCompanyId?: string
}

const ASSISTANCE_TYPES = [
  "End to End support",
  "End to End w/o Dr Consult",
  "Emergency doctor Consult",
  "Insurance Support",
  "Cancelled / Other",
]

export const CasesByClient: React.FC<Props> = ({
  selectedMonth,
  selectedQuarter = "",
  selectedCompanyId = "",
}) => {
  const [data, setData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth, selectedQuarter, selectedCompanyId])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const params: Record<string, any> = {}
      if (selectedQuarter) params.quarter = selectedQuarter
      if (selectedCompanyId) params.companyId = selectedCompanyId
      const res = await getMonthlyReportPivotCasesByClient(selectedMonth, params)
      setData(res.data?.data || [])
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  const rows = data.map((item: any) => {
    const values = Object.fromEntries(
      (item.assistances || []).map((a: any) => [a.type, a.count])
    )
    const total = ASSISTANCE_TYPES.reduce((sum, col) => sum + (values[col] || 0), 0)
    return {
      rowLabel: item._id,
      values,
      total,
    }
  })

  return (
    <Box mt={2}>
      {isLoading ? (
        <Flex justify="center" py={10}><Spinner /></Flex>
      ) : rows.length === 0 ? (
        <Text color="gray.400" textAlign="center" py={6}>No data</Text>
      ) : (
        <PivotTable rows={rows} columns={ASSISTANCE_TYPES} />
      )}
    </Box>
  )
}
